var Validator = require('jsonschema').Validator;
const validator = new Validator()

const andOrSchema = {
    "id": "/AndOrSchema",
    "type": "array",
    "minItems": 1,
    "items": {"$ref": "/OperatorSchema"}
};
validator.addSchema(andOrSchema, '/AndOrSchema');

const definedLocationsSchema = {
    "id": "/DefinedLocationSchema",
    "type": "object",
    "anyOf": [
        {"required": ["pois"]},
        {"required": ["on_device"]}
    ],
    "properties": {
        "on_device": {
            "minItems": 1,
            "type": "array",
            "items": {
                "type": "string",
                "enum": ["home", "work"]
            }
        },
        "pois": {
            "minItems": 1,
            "type": "array",
            "items": {
                "type": "string",
                "pattern": "^[a-z][a-z-]+$"
            }
        }
    },
    "additionalProperties": false
};
validator.addSchema(definedLocationsSchema, '/DefinedLocationSchema');

const belongsToSchema = {
    "id": "/BelongsToSchema",
    "type": "object",
    "required": ["target", "name"],
    "properties": {
        "target": {
            "type": "string",
            "enum": ["profiles"]
        },
        "name": {
            "type": "string",
        }
    },
    "additionalProperties": false
};
validator.addSchema(belongsToSchema, '/BelongsToSchema');

const acornCodeSchema = {
    "id": "/AcornCodeSchema",
    "type": "object",
    "required": ["code"],
    "properties": {
        "code": {
            "type": "integer",
            "maximum": 62,
            "minimum": 1,
        }
    },
    "additionalProperties": false
};
validator.addSchema(acornCodeSchema, '/AcornCodeSchema');

const hasVisited = {
    "id": "/HasVisited",
    "additionalProperties": false,
    "type": "object",
    "required": ["locations"],
    "properties": {
        "locations": {
            "type": "object",
            "anyOf": [{ "required": ["on_device"] }, { "required": ["pois"] }],
            "properties": {
                "target": {
                    "type": "string",
                    "enum": ["dbscan"],
                    "default": "dbscan"
                },
                "on_device": {
                    "minItems": 1,
                    "type": "array",
                    "items": {
                        "type": "string",
                        "enum": ["home"]
                    }
                },
                "pois": {
                    "minItems": 1,
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                }
            }
        }
    }
};
validator.addSchema(hasVisited, '/HasVisited');

const livesIn = {
    "id": "/LivesIn",
    "additionalProperties": false,
    "type": "object",
    "required": ["name"],
    "properties": {
        "name": {
            "type": "string",
            "minLength": 1
        }
    }
};
validator.addSchema(livesIn, '/LivesIn');

const timeSpentConsuming = {
    "id": "/TimeSpentConsuming",
    "additionalProperties": false,
    "type": "object",
    "required": ["period"],
    "anyOf": [{ "required": ["gte"] }, { "required": ["lt"] }],
    "properties": {
        "gte": {
            "type": "integer",
            "minimum": 1,
        },
        "lt": {
            "type": "integer",
            "minimum": 1,
        },
        "period": {
            "type": "integer",
            "minimum": 1,
        }
    }
};
validator.addSchema(timeSpentConsuming, '/TimeSpentConsuming');

const subscription = {
    "id": "/Subscription",
    "additionalProperties": false,
    "type": "object",
    "required": ["level"],
    "properties": {
        "level": {
            "type": "string",
        }
    }
};
validator.addSchema(subscription, '/Subscription');

const operatorSchema = {
  "id": "/OperatorSchema",
  "type": "object",
  "properties": {
    "and": {"$ref": "/AndOrSchema"},
    "or": {"$ref": "/AndOrSchema"},
    "not": {"$ref": "/OperatorSchema"},
    "belongs_to": {"$ref": "/BelongsToSchema"},
    "acorn_code": {"$ref": "/AcornCodeSchema"},
    "has_visited": {"$ref": "/HasVisited"},
    "lives_in": {"$ref": "/LivesIn"},
    "time_spent_consuming": {"$ref": "/TimeSpentConsuming"},
    "subscription": {"$ref": "/Subscription"},
  },
  "minProperties": 1,
  "maxProperties": 1,
  "additionalProperties": false
}
validator.addSchema(belongsToSchema, '/OperatorSchema');

export default Object.freeze({
  validate: (o) => validator.validate(o, operatorSchema),
})